module.exports = __webpack_public_path__ + "static/media/Hanna.bd2afb9f.png";